import React from 'react'
import './directory.styles.scss'
import { createStructuredSelector } from "reselect";
import { selectDirectorySections } from "../../redux/directory/directory.selectors";
import MenuItem from '../menu-item/menu-item.component'
import {connect} from 'react-redux'
const Directory = ({sections}) => {
    console.log(sections[0]);    
    return(
            <div className="directory-menu">
                {/* {
                    sections.map(({id, ...otherSectionProps}) =>(
                        <MenuItem key={id} {...otherSectionProps}/>
                    ))
                } */}
                <MenuItem key={sections[0].id} title={sections[0].title} imageUrl={sections[0].imageUrl} linkUrl={`shop/restaurants/r`}/>
                <MenuItem key={sections[1].id} title={sections[1].title} imageUrl={sections[1].imageUrl} linkUrl={sections[1].linkUrl}/>
                <MenuItem key={sections[2].id} title={sections[2].title} imageUrl={sections[2].imageUrl} linkUrl={sections[2].linkUrl}/>
            </div>
        );
            }
const MapStateToProps = createStructuredSelector({
    sections: selectDirectorySections
}) 
    

export default connect(MapStateToProps)(Directory);